import * as React from 'react';
import { Helmet } from 'react-helmet';

import { rest } from '@app/components/Api';
import LoginForm from '@app/components/Pages/Resources/Login/LoginForm';
import CentralStaticInfo from '@app/components/Pages/Resources/VetResources/CentralStaticInfo/CentralStaticInfo';
import { MustHeadText, MustHeadTitle, sliderItems, topics } from '@app/components/Pages/Resources/VetResources/VetResourcesContent';
import FiftyFifty from '@app/components/UI/FiftyFifty/FiftyFifty';
import Musthead from '@app/components/UI/MustHead/Musthead';
import SliderTes from '@app/components/UI/Slider/SliderTes';

import '@app/scss/components/vetResourceCenter.scss';

const VetResourceCenter = ({match}) => {
	const [isLogged, setIsLogged] = React.useState(false);
	const [currentTopic, setCurrentTopic] = React.useState<{ title: string, text: string, image: any }>();
	const [title, setTitle] = React.useState<string>();
	const [description, setDescription] = React.useState<string>();
	const [alt, setAlt] = React.useState<string>();
	const loginForm = React.useRef<any>();
	const signupForm = React.useRef<any>();

	const scrollToBlock = (ref) => {
		ref?.current?.scrollIntoView();
	};

	React.useEffect(() => {
		setCurrentTopic(topics[match.params.topic]);
	}, [match.params.topic]);

	React.useEffect(() => {
		if (currentTopic) {
			rest.get<{ title: string, description: string, alt: string }>(`v1/content/${currentTopic.title}`).then((res) => {
				setTitle(res.title);
				setDescription(res.description);
				setAlt(res.alt);
			});
		}
	}, [currentTopic]);

	return (
		<div className="vet-res-center">
			<Musthead
				title={MustHeadTitle}
				imageSrc={require('@app/content/Finding-the-Meaning-in-Mourning1.png')}
				imageAlt="Senior black dogs"
				text={MustHeadText}
				buttonText={<div className="musthead-body-quote__login">
					<div className="musthead-body-quote__login-text">Sign up to access the Veterinary Resource Center!</div>
					<div className="musthead-body-quote__login-btn">
						<button type="button" className="btn btn-primary" onClick={() => scrollToBlock(signupForm)}>Sign Up</button>
						<button type="button" className="btn btn-primary" onClick={() => scrollToBlock(loginForm)}>Log In</button>
					</div>
				</div>}
			/>

			{title && <Helmet>
				<title>{`${title} | Lap of Love`}</title>
				<meta name="description" property="og:description" content={description || undefined}/>
			</Helmet>}

			{currentTopic &&
			<FiftyFifty
				reversed
				title={currentTopic.title}
				text={currentTopic.text}
				src={currentTopic.image}
				alt={alt}
				extraBlock={<LoginForm setIsLogged={setIsLogged} match={match}/>}
			/>
			}

			<CentralStaticInfo loginRef={loginForm} signupRef={signupForm} />

			<div className="vet-res-center__slider-wrapper">
				<div className="vet-res-center__slider">
					<SliderTes
						sliderTesItemContent={sliderItems}
						title = {'Clinic testimonials'}
						location = {''}
					/>
				</div>
			</div>

		</div>
	);
};

export default VetResourceCenter;